"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertCheckinDaysArrayToDaysSelectionMap = exports.convertDaysSelectionMapToCheckinDaysArray = exports.allDaysAllowed = exports.factorDiscountToPercentage = exports.percentageDiscountToFactor = exports.NO_DISCOUNT_FACTOR = exports.getDisplayName = exports.getCurrencySymbol = exports.pricesHighLowFormatted = exports.CurrencyInfo = exports.CurrencyCodes = void 0;
const types_1 = require("../../types");
var CurrencyCodes;
(function (CurrencyCodes) {
    CurrencyCodes["GBP"] = "GBP";
    CurrencyCodes["EUR"] = "EUR";
    CurrencyCodes["USD"] = "USD";
})(CurrencyCodes = exports.CurrencyCodes || (exports.CurrencyCodes = {}));
exports.CurrencyInfo = {
    [CurrencyCodes.GBP]: { symbol: '£', code: 'GBP', displayName: '£ - Pounds Sterling' },
    [CurrencyCodes.EUR]: { symbol: '€', code: 'EUR', displayName: '€ - Euros' },
    [CurrencyCodes.USD]: { symbol: '$', code: 'USD', displayName: '$ - United States Dollars' }
};
const pricesHighLowFormatted = (min, max, currency) => {
    const symbol = (0, exports.getCurrencySymbol)(currency);
    return `(${symbol}${min} to ${symbol}${max})`;
};
exports.pricesHighLowFormatted = pricesHighLowFormatted;
const getCurrencySymbol = (currency) => { var _a; return ((_a = exports.CurrencyInfo[currency]) === null || _a === void 0 ? void 0 : _a.symbol) || '#'; };
exports.getCurrencySymbol = getCurrencySymbol;
const getDisplayName = (currency) => exports.CurrencyInfo[currency].displayName;
exports.getDisplayName = getDisplayName;
const DISCOUNT_FACTOR_TO_PERCENTAGE = 0.01;
exports.NO_DISCOUNT_FACTOR = 1;
/**
 * Convert a discount expressed as a percentage to a multiplication factor.
 *
 * @example
 * // returns 0.9
 * percentageDiscountToFactor(10);
 *
 * @param percentage
 * @returns factor {number}
 */
const percentageDiscountToFactor = (percentage) => parseFloat(((100 - percentage) * DISCOUNT_FACTOR_TO_PERCENTAGE).toFixed(2));
exports.percentageDiscountToFactor = percentageDiscountToFactor;
/**
 * Convert a discount expressed as a multiplication factor to a percentage.
 *
 *
 * @example
 * // returns 25
 * percentageDiscountToFactor(0.75);
 *
 * @param factor
 * @returns percentage {number}
 */
const factorDiscountToPercentage = (factor) => 100 - Math.round(factor / DISCOUNT_FACTOR_TO_PERCENTAGE);
exports.factorDiscountToPercentage = factorDiscountToPercentage;
/**
 * Retrieve an all-days-allowed DaysSelectionMap.
 * @returns {arrivalDays} - all allowed
 */
const allDaysAllowed = () => {
    return Object.keys(types_1.DaysOfWeekFullNames).reduce((acc, day) => {
        return Object.assign(Object.assign({}, acc), { [day]: true });
    }, {});
};
exports.allDaysAllowed = allDaysAllowed;
/**
 * Convert a map of arrival days to the representive check-in day-of-week array.
 *
 * @example
 * // returns ['mon', 'tue', 'wed']
 * convertDaysSelectionMapToCheckinDaysArray({
 * 		mon: true,
 * 		tue: true,
 * 		wed: true,
 * 		thur: false,
 * 		fri: false,
 * 		sat: false,
 * 		sun: false
 * })
 *
 * @param arrivalDays
 * @returns checkinDays {string[]} - the selected days of the week.
 */
const convertDaysSelectionMapToCheckinDaysArray = (selectedCheckinDays) => {
    return Object.keys(selectedCheckinDays).filter((dow) => selectedCheckinDays[dow]);
};
exports.convertDaysSelectionMapToCheckinDaysArray = convertDaysSelectionMapToCheckinDaysArray;
/**
 * Convert an array of check-in days-of-week to an arrival days map.
 *
 * @example
 * // returns {
 * // mon: true,
 * // tue: true,
 * // wed: true,
 * // thur: false,
 * // fri: false,
 * // sat: false,
 * // sun: false
 * //})
 * convertCheckinDaysArrayToDaysSelectionMap(['mon', 'tue', 'wed'])
 *
 * @paramselectedCheckinDays
 * @returns selectedCheckinDays {DaysSelectionMap} - the selected checkin days.
 */
const convertCheckinDaysArrayToDaysSelectionMap = (checkinDays) => {
    return Object.keys(types_1.DaysOfWeekFullNames).reduce((all, shortName) => (Object.assign(Object.assign({}, all), { [shortName]: checkinDays.includes(shortName) })), {});
};
exports.convertCheckinDaysArrayToDaysSelectionMap = convertCheckinDaysArrayToDaysSelectionMap;
//# sourceMappingURL=helpers.js.map